import SendEventBackend from "../../../../contents/docs/getting-started/_snippets/send-event-backend.mdx";
import * as React from 'react';
export default {
  SendEventBackend,
  React
};